module.exports = __webpack_public_path__ + "static/bluewhale6-f6b0a382cd109df7af5b16c0b22ef40f.png";